export const baseWords_en = {
    btns: {
        stand3D: 'Go to 3D stand'
    },
    errorText: {
        message: 'Unrnown error'
    }
}